/*jshint esversion: 6 */
import { find, map, sortBy } from 'lodash-es';

// WIS API proxied via tariffs backend
export let wisOccupationsService = function (locale) {
    const url = import.meta.env.VITE_APP_TARIFFS_API_URL;

    const treeItem = (item) => {
        return {
            id: item.id,
            name: item.translations[locale],
        };
    };

    const that = {};
    that._getOccupations = async () => {
        const response = await fetch(
            `${url}api/search-tree/1.0/trees/occupations_GIGGIZ/${locale}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return await response.json();
    };

    that.getLevelOneOccupations = async () => {
        const data = await that._getOccupations();

        let occupations = map(data.children, treeItem);
        occupations = sortBy(occupations, ['name']);
        return occupations;
    };

    that.getLevelTwoOccupations = async (levelOneOccupationId) => {
        const data = await that._getOccupations();

        const levelOneRegion = find(data.children, {
            id: levelOneOccupationId,
        });

        let occupations = map(levelOneRegion.children, treeItem);
        occupations = sortBy(occupations, ['name']);
        return occupations;
    };

    return that;
};
